import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, CalendarX2, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { EV } from "@/pages/eventsText";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function EventCancelPage() {
  const { token } = useParams();
  const { lang } = useLang();
  const x = EV[lang] || EV.en;
  const [info, setInfo] = useState(undefined);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/events/cancel/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo(null)); }, [token]);
  const cancel = async () => {
    setBusy(true);
    try { await api.post(`/events/cancel/${token}`); setDone(true); } catch { setInfo(null); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100">
      <SiteHeader />
      <main className="mx-auto max-w-md px-5 py-16">
        <div className="rounded-2xl border border-zinc-800/70 bg-[#111113] p-7 text-center" data-testid="event-cancel">
          {info === undefined ? <Loader2 className="mx-auto animate-spin text-zinc-500" /> : done ? (
            <><CheckCircle2 size={40} className="mx-auto text-emerald-400" /><p className="mt-3 text-[15px]" data-testid="event-cancel-done">{x.cancelDone}</p></>
          ) : info === null ? (
            <><CalendarX2 size={40} className="mx-auto text-zinc-500" /><p className="mt-3 text-[15px] text-zinc-300" data-testid="event-cancel-notfound">{x.notFound}</p></>
          ) : (
            <>
              <h1 className="text-xl font-bold">{x.cancelTitle}</h1>
              <p className="mt-2 text-[15px] font-semibold text-zinc-100">{info.title}</p>
              <p className="text-[13px] text-zinc-500">{new Date(info.starts_at).toLocaleString()} · {info.email}</p>
              <p className="mt-4 text-[14px] text-zinc-400">{x.cancelQ}</p>
              <button data-testid="event-cancel-confirm" onClick={cancel} disabled={busy} className="mt-5 inline-flex items-center gap-2 rounded-full bg-red-600 px-5 py-2.5 text-[14px] font-semibold text-white hover:bg-red-500 disabled:opacity-50">
                {busy && <Loader2 size={15} className="animate-spin" />} {x.cancelBtn}
              </button>
            </>
          )}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
